import React, { useCallback, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import NivelDeRisco from './NivelDeRisco';
import Periodo from './Periodo';
import EstacaoColecao from './EstacaoColecao';
import Permanencia from './Permanencia';
import { Grid } from '@material-ui/core';
import { showError, showLoading, hideLoading } from '../../../../actions';
import { getMateriaisPermanente } from '../../../../services/DadoMestreService';
import { transformPvIntoPeriodo } from './Utils';
import CheckBoxListItem from './CheckBoxListItem';

const filterByPeriods = (items, periodos) => items.filter((item) => periodos.includes(transformPvIntoPeriodo(item.pv)));
const filterByEstacaoColecao = (items, estacoesColecoes) =>
    items.filter(({ estacao, colecao }) => estacoesColecoes.includes(`${estacao}/${colecao}`));
const filterByPermanencia = (items, permanentes, flag) => {
    if (flag.length > 1) {
        return items;
    }

    switch (flag[0]) {
        case 'Permanente':
            return items.filter(({ material }) => permanentes.includes(material));
        case 'Não Permanente':
            return items.filter(({ material }) => !permanentes.includes(material));
        default:
            return items;
    }
};

const applyNivelDeRisco = (items, niveisDeRisco) => {
    if (typeof niveisDeRisco === 'boolean') {
        return items.map((item) => ({
            ...item,
            atualizar: 'qtdNecMulti',
        }));
    }

    let newItems = [...items];

    newItems = newItems.map((item) => {
        const observacao = (item.nivelRisco || '').toLowerCase();
        let nivelDeRisco = niveisDeRisco[observacao] || niveisDeRisco['medio'];

        if (niveisDeRisco.estoqueSeguranca) {
            return {
                ...item,
                percEstoqueSeg: nivelDeRisco,
                atualizar: 'percEstoqueSeg',
            };
        }

        return {
            ...item,
            percAnt: nivelDeRisco,
            vendaFutura: niveisDeRisco.vendaFutura,
            atualizar: 'percAnt',
        };
    });

    return newItems;
};

const beforeSave = (permanentes, items, { value, isEmpty }, showError, save, agruparNecessidade) => {
    if (isEmpty()) {
        return showError('Você precisa preencher pelo menos um valor em cada separação!');
    }
    const firstFilter = filterByPeriods(items, value['periodo']);
    const secondFilter = filterByEstacaoColecao(firstFilter, value['estacao/colecao']);
    const thirdFilter = filterByPermanencia(secondFilter, permanentes, value['permanencia']);
    if (agruparNecessidade && thirdFilter.length === 0) {
        return showError('Nenhum material encontrado pra antecipar com esses filtros!');
    } else if (secondFilter.length === 0) {
        return showError('Nenhum material encontrado pra antecipar com esses filtros!');
    }

    let itemsAlterados = thirdFilter;
    if (!agruparNecessidade) itemsAlterados = applyNivelDeRisco(secondFilter, value['nivelDeRisco']);
    save(
        itemsAlterados.map((line) => ({
            ...line,
            checked: false,
            apenasPorMaterial: value['apenasPorMaterial'],
            permanencia: value['permanencia'],
        }))
    );
};

const fetchMateriaisPermante = async (setPermanencia) => {
    const result = await getMateriaisPermanente();
    setPermanencia(result);
};

const Antecipacao = ({ showError, items, isOpen, onClose, onSave, showLoading, hideLoading, agruparNecessidade = true }) => {
    const [materiaisPermanente, setMateriaisPermanentes] = useState(null);
    const [isSaving, setSaving] = useState(false);

    const handleSave = useCallback(() => {
        showLoading();
        setSaving(true);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        fetchMateriaisPermante(setMateriaisPermanentes);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (isSaving === true) {
            const stateless = AntecipacaoStateless._instance;
            stateless.setAgruparNecessidade(agruparNecessidade);
            beforeSave(materiaisPermanente, items, stateless, showError, onSave, agruparNecessidade);
            setSaving(false);
        }
    }, [isSaving]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        setSaving(false);
        if (isOpen && items.length > 0) hideLoading();
    }, [items, isOpen]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <Modal isOpen={isOpen} toggle={onClose} className='modal-xl mw-60 w-60'>
            <ModalHeader className='modal-title' style={{ position: 'relative', textAlign: 'center', height: 50 }}>
                <span style={{ position: 'absolute', left: '41%' }}>
                    {agruparNecessidade ? 'Agrupar necessidade' : 'Antecipação de Previsão'}
                </span>
            </ModalHeader>
            <ModalBody>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={3}>
                        <Periodo items={items} stateless={AntecipacaoStateless._instance} />
                    </Grid>
                    {!agruparNecessidade && (
                        <Grid item xs={12} md={3}>
                            <NivelDeRisco stateless={AntecipacaoStateless._instance} />
                        </Grid>
                    )}
                    <Grid item xs={12} md={3}>
                        <EstacaoColecao items={items} stateless={AntecipacaoStateless._instance} />
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <Permanencia stateless={AntecipacaoStateless._instance} />
                    </Grid>
                </Grid>
            </ModalBody>
            <ModalFooter className='d-flex flex-row justify-content-between align-items-center p-0' style={{ maxHeight: 72 }}>
                <div className='form-group form-check form-item mt-3'>
                    {!agruparNecessidade && (
                        <CheckBoxListItem
                            items={['Apenas por material']}
                            name={'apenasPorMaterial'}
                            stateless={AntecipacaoStateless._instance}
                        />
                    )}
                </div>
                <div className='pr-3' style={{ margin: agruparNecessidade ? 16 : 0 }}>
                    <Button type='submit' size='md' color='primary' onClick={handleSave} className='mr-2'>
                        Salvar
                    </Button>
                    <Button color='secondary' onClick={onClose}>
                        Cancelar
                    </Button>
                </div>
            </ModalFooter>
        </Modal>
    );
};

class AntecipacaoStateless {
    constructor() {
        this.value = {};
        this.agruparNecessidade = false;
    }

    isEmpty = () => AntecipacaoStateless._isEmpty(this.value, this.agruparNecessidade);

    setValue(key, value) {
        this.value[key] = value;
    }

    setAgruparNecessidade(value) {
        this.agruparNecessidade = value;
    }

    static _isEmpty = (value, agruparNecessidade) => {
        if (Object.keys(value).length === 0) return true;

        if (!value.hasOwnProperty('periodo')) return true;

        if (!agruparNecessidade && !value.hasOwnProperty('nivelDeRisco')) return true;

        if (!value.hasOwnProperty('estacao/colecao')) return true;

        if (!value.hasOwnProperty('permanencia')) return true;

        if (
            !agruparNecessidade &&
            typeof value['nivelDeRisco'] === 'object' &&
            (Object.keys(value['nivelDeRisco']).length === 0 || Object.values(value['nivelDeRisco']).every((valor) => !valor))
        )
            return true;

        return false;
    };

    static _instance = new AntecipacaoStateless();
}

const mapStateToProps = (_) => ({});
const mapDispatchToProps = (dispatch) => bindActionCreators({ showError, showLoading, hideLoading }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Antecipacao);
